import { walletState } from '@/atom/wallet';
import { Logout } from '@mui/icons-material';
import { Button, CardHeader } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';

export default function Header({ title = '' }: { title: string }) {
  const [, setWallet] = useRecoilState(walletState);
  const navigate = useNavigate();
  return (
    <CardHeader
      title={title}
      action={
        <Button
          variant="contained"
          endIcon={<Logout />}
          onClick={() => {
            setWallet(false);
            sessionStorage.removeItem('code');
            sessionStorage.removeItem('login');
            navigate('/');
          }}
        >
          logout
        </Button>
      }
    />
  );
}
